export type OpeningHoursLanguage = 'nl' | 'en'

const DUTCH_OPENING_HOURS_BASE_URL =
  'https://www.royalfloraholland.com/inkopen-2/logistiek/logistieke-middelen/alles-over-fust/inname-en-uitgifte-fust'

const ENGLISH_OPENING_HOURS_BASE_URL =
  'https://www.royalfloraholland.com/en/buying-2/logistics/transport-packaging/all-about-packaging/collecting-and-returning-packaging'

const GENERIC_OPENING_HOURS_QUERY_BY_LANGUAGE: Record<
  OpeningHoursLanguage,
  string
> = {
  nl: '?accordion%5Baccordion-layout%5D%5B0%5D=richtlijnen-inname-uitgifte-fust&accordion%5Baccordion-layout%5D%5B1%5D=',
  en: '?accordion%5Baccordion-layout%5D%5B0%5D=general-guidelines&accordion%5Baccordion-layout%5D%5B1%5D=',
}

export const openingHoursMapper = (
  hub: string
): {
  collectDutchUrl: string
  returnDutchUrl: string
  collectEnUrl: string
  returnEnUrl: string
} => {
  const collectingHoursDutch = new Map<string, string>([
    [
      'Aalsmeer',
      '?accordion%5Baccordion-layout%5D%5B0%5D=aalsmeer-uitgifte&accordion%5Baccordion-layout%5D%5B1%5D=',
    ],
    [
      'Naaldwijk',
      '?accordion%5Baccordion-layout%5D%5B0%5D=naaldwijk-uitgifte&accordion%5Baccordion-layout%5D%5B1%5D=',
    ],
    [
      'Rijnsburg',
      '?accordion%5Baccordion-layout%5D%5B0%5D=rijnsburg-uitgifte&accordion%5Baccordion-layout%5D%5B1%5D=',
    ],
  ])
  const returningHoursDutch = new Map<string, string>([
    [
      'Aalsmeer',
      '?accordion%5Baccordion-layout%5D%5B0%5D=aalsmeer-inname&accordion%5Baccordion-layout%5D%5B1%5D=',
    ],
    [
      'Naaldwijk',
      '?accordion%5Baccordion-layout%5D%5B0%5D=naaldwijk-inname&accordion%5Baccordion-layout%5D%5B1%5D=',
    ],
    [
      'Rijnsburg',
      '?accordion%5Baccordion-layout%5D%5B0%5D=rijnsburg-inname&accordion%5Baccordion-layout%5D%5B1%5D=',
    ],
  ])
  const collectingHoursEnglish = new Map<string, string>([
    [
      'Aalsmeer',
      '?accordion%5Baccordion-layout%5D%5B0%5D=aalsmeer-collecting&accordion%5Baccordion-layout%5D%5B1%5D=',
    ],
    [
      'Naaldwijk',
      '?accordion%5Baccordion-layout%5D%5B0%5D=naaldwijk-collecting&accordion%5Baccordion-layout%5D%5B1%5D=',
    ],
    [
      'Rijnsburg',
      '?accordion%5Baccordion-layout%5D%5B0%5D=rijnsburg-collecting&accordion%5Baccordion-layout%5D%5B1%5D=',
    ],
  ])
  const returningHoursEnglish = new Map<string, string>([
    [
      'Aalsmeer',
      '?accordion%5Baccordion-layout%5D%5B0%5D=aalsmeer-returning&accordion%5Baccordion-layout%5D%5B1%5D=',
    ],
    [
      'Naaldwijk',
      '?accordion%5Baccordion-layout%5D%5B0%5D=naaldwijk-returning&accordion%5Baccordion-layout%5D%5B1%5D=',
    ],
    [
      'Rijnsburg',
      '?accordion%5Baccordion-layout%5D%5B0%5D=rijnsburg-returning&accordion%5Baccordion-layout%5D%5B1%5D=',
    ],
  ])
  return {
    collectDutchUrl: collectingHoursDutch.get(hub) || '',
    returnDutchUrl: returningHoursDutch.get(hub) || '',
    collectEnUrl: collectingHoursEnglish.get(hub) || '',
    returnEnUrl: returningHoursEnglish.get(hub) || '',
  }
}

export const getOpeningHoursOverviewUrl = (
  language: OpeningHoursLanguage
): string => {
  const baseUrl =
    language === 'en'
      ? ENGLISH_OPENING_HOURS_BASE_URL
      : DUTCH_OPENING_HOURS_BASE_URL

  return `${baseUrl}${GENERIC_OPENING_HOURS_QUERY_BY_LANGUAGE[language]}`
}

export const getCollectingOpeningHoursUrl = (
  hub: string,
  language: OpeningHoursLanguage
): string => {
  const urls = openingHoursMapper(hub)
  const path = language === 'en' ? urls.collectEnUrl : urls.collectDutchUrl

  if (!path) {
    return getOpeningHoursOverviewUrl(language)
  }

  const baseUrl =
    language === 'en'
      ? ENGLISH_OPENING_HOURS_BASE_URL
      : DUTCH_OPENING_HOURS_BASE_URL

  return `${baseUrl}${path}`
}

export const getReturningOpeningHoursUrl = (
  hub: string,
  language: OpeningHoursLanguage
): string => {
  const urls = openingHoursMapper(hub)
  const path = language === 'en' ? urls.returnEnUrl : urls.returnDutchUrl

  if (!path) {
    return getOpeningHoursOverviewUrl(language)
  }

  const baseUrl =
    language === 'en'
      ? ENGLISH_OPENING_HOURS_BASE_URL
      : DUTCH_OPENING_HOURS_BASE_URL

  return `${baseUrl}${path}`
}
